<template>
  <div>
    <v-card class="pa-10" elevation="0">
      <v-row>
        <v-col>
          <v-row no-gutters align="center">
            <h4 class="greyDark--text font-weight-bold mb-0">
              {{ $t('common:process_plural') }}
            </h4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs}">
                <v-btn class="ml-2" icon @click="cardView = !cardView" v-bind="attrs" v-on="on">
                  <v-icon>list_alt</v-icon>
                </v-btn>
              </template>
              <span v-if="cardView">{{ $t('buttons:table-view') }}</span>
              <span v-else>{{ $t('buttons:card-view') }}</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <BaseButton
              color="primary"
              :btnText="$t('buttons:add-specific', { specific: $t('common:process')})"
              @clickedButton="openFormDialog"
          />
        </v-col>
        <v-col cols="12" class="pt-0" v-show="!cardView">
          <DataTablePaginated
              ref="tableFacilityProcess"
              class="ma-1"
              :headers="processHeaders"
              @updateTableData="updateFacilityProcessTable"
              icon="create"
              icon2="delete"
              icon3="restore"
              :iconTooltip="$t('buttons:edit')"
              :iconTooltip2="$t('buttons:delete')"
              :iconTooltip3="$t('buttons:restore')"
              dependsOnProperty3="deleted"
              @clickedButton1="editProcess"
              @clickedButton2="deleteProcess"
              @clickedButton3="restoreProcess"
              checkbox-on-property="lastResult"
              sortBy="process.name"
              @cacheCommit="$store.commit('book/facility/storeFacilityProcessSearch', $event)"
              :cachedSearch="$store.state.book.facility.processSearch"
              :show-select="isAdmin"
              @changedItemSelection="onItemSelectionChanged"
              @clickedSelectionButton1="onClickMultiDelete"
              :selectionButton1Text="multiDeleteButtonText"
              selectionButton1Color="error"

          />
        </v-col>
      </v-row>

      <div v-show="cardView">
        <SearchAndSortBar
            @updateData="updateFacilityProcessTable"    
            @cacheCommit="$store.commit('book/facility/storeFacilityProcessSearch', $event)"
            :cachedSearch="$store.state.book.facility.processSearch"
            :sorts="processHeaders"
            default-sort-by="processName"
            disable-filter
        />
        <v-row>       
          <v-col cols="12" md="6" :lg="cardSize" xl="4" v-for="(item, i) in restProcess.content" :key="i" >
              <ItemCard
                  :item="item"
                  :title="item.processName"
                  :subtitle="$t('book/facility:facility.dashboard.information.processes.card-items.assigned-role') + ': ' + item.assignedToRoleName"
                  :subtitle2="$t('common:status') + ': '
                    + (item.lastResult ? $t('common.success') :
                    $t('book/facility:facility.dashboard.information.processes.card-items.failed'))"
                  hideActionBtn1
                  hideActionBtn2
                  hideActionBtn3
                  hideChart
                  hideViewBtn
                  cardElevation
                  showDelete
                  @viewItem="editProcess(item)"
                  @deleteItem="deleteProcess(item)"
              />
          </v-col>
        </v-row>
        <v-pagination v-show="this.restProcess.content.length !== 0"
            v-model="restProcess.options.page"
            :length="totalPages"
            :total-visible="7">
        </v-pagination>
      </div>
      <v-col v-if="restProcess.content.length === 0" class="text-center">
        <h6 class="greyTint--text mb-0">
          {{ $t('common:no-data-found') }}
        </h6>
      </v-col>      
    </v-card>

    <FacilityProcessDialogForm
        ref="processForm"
        @updateProcessData="updateFacilityProcessTable"
    />

    <TwoButtonDialog
        ref="restoreProcessJobButton"
        :btn-text="$t('buttons:restore')"
        color="grey"
        :dialog-title="$t('dialog:restore-btn-title',{name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-1')})"
        :dialog-text="$t('dialog:restore-btn-dialog',{name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-2')})"
        :button2-text="$t('buttons:restore')"
        :button1-text="$t('buttons:cancel')"
        @clickedButton1="$refs.restoreProcessJobButton.showDialog = false"
        @clickedButton2="restoreProcessConfirmed()"
        :hide-button="true"
    />

    <TwoButtonDialog
        ref="deleteProcessJobButton"
        :btn-text="$t('buttons:delete')"
        color="grey"
        :dialog-title="$t('dialog:delete-btn-title',{name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-1')})"
        :dialog-text="$t('dialog:delete-btn-dialog',{name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-2')})"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        @clickedButton1="$refs.deleteProcessJobButton.showDialog = false"
        @clickedButton2="deleteProcessConfirmed(true)"
        :hide-button="true"
    />

    <ThreeButtonDialog
        ref="deleteAdminProcessJobButton"
        :hide-button="true"
        color="grey"
        :btn-text="$t('buttons:delete')"
        :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-1')})"
        :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/facility:facility.dashboard.information.processes.table.dialog-part-2')})"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        :button3-text="$t('dialog:delete-btn-3-text')"
        @clickedButton1="$refs.deleteAdminProcessJobButton.showDialog = false"
        @clickedButton2="deleteProcessConfirmed(false)"
        @clickedButton3="deleteProcessConfirmed(true)"
    />
    <ThreeButtonDialog
        ref="multiDeleteAdminProcessJobButton"
        :hide-button="true"
        color="grey"
        :btn-text="$t('buttons:delete')"
        :dialog-title="$t('dialog:delete-multi-btn-title',
            {name : $t('book/facility:facility.dashboard.information.processes.table.dialog-multi-part-1'),
             number : multiDeleteNumber })"
        :subtitle-text=" $t('dialog:delete-multi-btn-dialog',
            {name : $t('book/facility:facility.dashboard.information.processes.table.dialog-multi-part-2'),
             number : multiDeleteNumber })"
        :add-info-text="multiDeleteDialogText"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        :button3-text="$t('dialog:delete-btn-3-text')"
        @clickedButton1="$refs.multiDeleteAdminProcessJobButton.showDialog = false"
        @clickedButton2="multiDeleteProcessConfirmed(false)"
        @clickedButton3="multiDeleteProcessConfirmed(true)"
    />
  </div>
</template>
<script>

import ProcessJobService from '@/modules/book/services/process/impl/process-job-service'

import Utils from "@/modules/core/services/utils";

import ItemCard from '@/modules/core/components/ItemCard'
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import ThreeButtonDialog from "@/modules/core/components/TwoButtonDialog/ThreeButtonDialog";
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";
import FacilityProcessDialogForm from "../formDialogs/FacilityProcessDialogForm"
import BaseButton from "@/modules/core/components/Base/BaseButton";
import SearchAndSortBar from "@/modules/core/components/SearchAndSortBar";
import {Role} from "@/modules/core/data/roles";

import {mapState} from 'vuex'

export default {
  name: 'FacilityProcessInfoTab',
  components: {
    ItemCard,
    TwoButtonDialog,
    ThreeButtonDialog,
    DataTablePaginated,
    FacilityProcessDialogForm,
    BaseButton,
    SearchAndSortBar
  },
  data() {
    return {
      cardView: false,
      restProcess: {
        options: [],
        search: [],
        content: []
      },
      totalPages: null,
      selectedItemsForDelete: [],
      deleteProcessIdArray: []
    }
  },
  computed: {
    multiDeleteNumber() {
      return this.selectedItemsForDelete.length;
    },
    multiDeleteButtonText() {
      return this.$t("buttons:multi-delete", { number: this.multiDeleteNumber,
        items:  this.$t('common:process_plural') });
    },
    multiDeleteDialogText() {
      let processesString= "";
      for (let i=0; i<this.selectedItemsForDelete.length; i++) {
        if (processesString !== "") {
          processesString += "<br>";
        }
        const process= this.selectedItemsForDelete[i];
        processesString += process.processName + " " + process.date;
      }
      return processesString;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      if( this.$store.state == null || this.$store.state.auth == null){
        return null;
      }
      return this.$store.state.auth.user;
    },
    processHeaders() {
      return [
        {text: this.$t("common:process"), value: "processName"},
        {text: this.$t("common:role"), value: "assignedToRoleName"},
        {text: this.$t("common:date"), value: "date"},
        {text: this.$t("book/facility:facility.dashboard.information.processes.table.col-4"), value: "checkbox"},
        {text: "", value: "controls", width: "140px", sortable: "false"},
      ];
    },
    cardSize() {
      // if both sidebars are fully opened, make card size bigger
      if(this.leftFacilityDrawer && this.rightFacilityDrawer) {
        return '6'
        // if both side bars are closed, make card size smaller
      } else if(!this.leftFacilityDrawer && !this.rightFacilityDrawer) {
        return '3'
      } else {
        return '4'
      }
    },

    ...mapState('book/layout', {
      leftFacilityDrawer: state => state.leftFacilityDrawer,
      rightFacilityDrawer: state => state.rightFacilityDrawer
    }),
  },
  methods: {
    updateFacilityProcessTable(options, search) {
      this.restProcess.options = options;
      this.restProcess.search = search;

      if(!search) search = '';
      this.$refs.tableFacilityProcess.loading = true;
      ProcessJobService.readPageableFacilityProcessJobFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (res) => {
          if(this.$refs.tableFacilityProcess !== undefined) {
            this.$refs.tableFacilityProcess.fillTableData(res.data);
            this.restProcess.content = res.data.content

            this.totalPages = res.data.totalPages;            
            
            this.$emit('updateQuicklinkProcesses')
          }
        },
        (error) => {
          this.$refs.tableFacilityProcess.loading = false;
          this.$logger.info("Error at fetching facility processes: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:process_plural')}))
        }
      )
    },

    deleteProcess(item) {
      this.deleteProcessId = item;
      if (this.isAdmin) {
        this.$refs.deleteAdminProcessJobButton.showDialog = true;
        this.$refs.deleteAdminProcessJobButton.hideThirdButton = item.deleted === true;
      } else {
        this.$refs.deleteProcessJobButton.showDialog = true;
      }
    },

    restoreProcess(item) {
      this.restoreProcessId = item;
      this.$refs.restoreProcessJobButton.showDialog = true;
    },

    restoreProcessConfirmed() {
      ProcessJobService.restoreFromAPI(this.restoreProcessId,
        () => {
          this.updateFacilityProcessTable(this.restProcess.options, this.restProcess.search)
          Utils.showSuccessSnackbar(this.$t('snackbar:restore-success', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}));
        },
        (error) => {
          this.$logger.error("Failed to restore process job, because: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:restore-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}))
        }
      )
      this.$refs.restoreProcessJobButton.showDialog = false;
    },

    deleteProcessConfirmed(softDelete) {
      ProcessJobService.deleteFromAPI(this.deleteProcessId, softDelete,
        () => {
          this.updateFacilityProcessTable(this.restProcess.options, this.restProcess.search)
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}));
        },
        (error) => {
          this.$logger.error("Failed to delete process job, because: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}))
        }
      )
      this.$refs.deleteProcessJobButton.showDialog = false;
      this.$refs.deleteAdminProcessJobButton.showDialog = false;
    },

    openFormDialog() {
      this.$refs.processForm.addProcess(this.restProcess.options, this.restProcess.search)
    },

    editProcess(item) {
      this.$refs.processForm.editProcess(item, this.restProcess.options, this.restProcess.search)
    },
    /**
     * Handling custom event for multi-selection changed in DataTablePaginated
     * @param items array of processJobs
     */
    onItemSelectionChanged(items) {
      this.selectedItemsForDelete = items;
    },

    onClickMultiDelete(items) {
      if (items == null || items.length === 0){
        return;
      }
      this.selectedItemsForDelete= items;
      this.deleteProcessIdArray = items.map( item => item.id);
      if (this.isAdmin) {
          this.$refs.multiDeleteAdminProcessJobButton.showDialog = true;
      }
    },

    multiDeleteProcessConfirmed(softDelete) {
        ProcessJobService.deleteItemsFromAPI(this.deleteProcessIdArray, softDelete,
            () => {
              this.$refs.tableFacilityProcess.clearSelection();
              this.updateFacilityProcessTable(this.restProcess.options, this.restProcess.search);
              Utils.showSuccessSnackbar(this.$t('snackbar:delete-multi-success', {name: this.$t('common:process_plural')}));
            },
            (error) => {
              this.$refs.tableFacilityProcess.clearSelection();
              this.$logger.error("Failed to delete process job, because: " + error);
              this.updateFacilityProcessTable(this.restProcess.options, this.restProcess.search);
              Utils.showFailureSnackbar(this.$t('snackbar:delete-multi-failure', {name: this.$t('common:process_plural')}))
            }
        )
        this.$refs.multiDeleteAdminProcessJobButton.showDialog = false;
    }


  }
}
</script>